import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { messages } from './messages';

export const ReturnTo = {
  id: 'returnsShipTo',
  displayName: <FormattedMessage {...messages.shipTo} />,
  type: OptionFormTypes.TYPE_CHECKLIST,
  filterValue: 'shipFromId',
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },

  shouldHideActionButtons: true,
};
